import { useEffect, useState } from 'react';
import { faCheckCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';

import { For, If, createComponent, createPage } from '@lib/util/templateHelpers';
import shared from '@lib/components';
const { Box, Block, Title, Loader, Flex, Icon, RouterLink, Content, DocumentTitle } = shared;

import styles from './index.module.scss';
import { useAuthStore } from '@/stores/auth'; 
import gameApi from '@/apis/drupal/game';
import DeveloperLayout from '@/layouts/DeveloperLayout';

const GameRow = createComponent('GameRow', {}, function GameRow ({}, props) {
  return (
    <tr>
      <td>
        {props.game.title}
      </td>
      <td>
        <RouterLink href={props.game.path}><img src={props.game.thumbnailUrl} /></RouterLink>
      </td>
      <td>
        {
          If(props.game.status, () => (
            <Flex alignCenter justifyCenter inline>
              <Icon.FA icon={faCheckCircle} title='Published' className='GameRow--published' />
              <small>Published</small>
            </Flex>
          ))
          .Else(() => (
            <Flex alignCenter justifyCenter inline>
              <Icon.FA icon={faTimesCircle} title='Unpublished' className='GameRow--unpublished' /> 
              <small>Unpublished</small>
            </Flex>
          ))
          .EndIf()
        }
      </td>
      <td>
        {
          If(props.game.featured, () => (
            <>{props.game.featuredUntil}</>
          ))
          .Else(() => (
            <>—</>
          ))
          .EndIf()
        }
      </td>
      <td>
        <RouterLink href={`/developer/edit-game/${props.game.id}`}>Edit</RouterLink>
      </td>
    </tr>
  );
});

export default createPage('DeveloperPage', { styles }, function DeveloperPage ({ className }) {
  const [ state ] = useAuthStore();

  const [ loadingGames, setLoadingGames ] = useState(true);
  const [ developerGames, setDeveloperGames ] = useState([]);
  
  // Redirect to login if not logged in
  useEffect(() => {
    if (!state.ready || !state.auth) return;

    (async () => {
      const games = await gameApi.listByDeveloper(state.user.id, 50);
      setDeveloperGames(games);
      setLoadingGames(false);
    })();
  }, [ state ]);

  return (
    <>
      <DocumentTitle title='Developer Dashboard' />

      <DeveloperLayout className={className}>
        {
          If(!state.ready, () => (
            <Loader.Fill large />
          ))
          .ElseIf(state.ready && !!state.auth, () => (
            <Box>
              <Block>
                <Block>
                  <Title>Published Games</Title>
                </Block>
                <Block className='DeveloperPage__PublishedGameList' style={{ position: 'relative' }}>
                  {
                    If(loadingGames, () => (
                      <Flex wide tall alignCenter justifyCenter>
                        <Flex><Loader /></Flex>
                      </Flex>
                    ))
                    .ElseIf(developerGames.length === 0, () => (
                      <Content className='--textCenter --padMd1'>
                        <p>You haven't published any games yet!</p>
                        <p><RouterLink href='/developer/add-game'>Add your game</RouterLink></p>
                      </Content>
                    ))
                    .Else(() => (
                      <table width='100%'>
                        <tbody>
                          {
                            For(developerGames, (game) => (
                              <GameRow key={game.id} game={game} />
                            ))
                          }
                        </tbody>
                      </table>
                    ))
                    .EndIf()
                  }
                </Block>
              </Block>
            </Box>
          ))
          .EndIf()
        } 
      </DeveloperLayout>
    </>
  )
});
